import { Tooltip, useTheme } from '@mui/material';
import DiscontinuedIcon from '@mui/icons-material/NotInterested';
import LoopIcon from '@mui/icons-material/Loop';
import { KitItem } from '../types';

const RefillStatus = ({ item }: { item: KitItem }) => {
  const theme = useTheme();

  if (item.active && item?.item?.is_discontinued) {
    return (
      <Tooltip title="Item is Discontinued">
        <DiscontinuedIcon sx={{ color: theme.palette.inactive.main }} fontSize="small" />
      </Tooltip>
    );
  } else if (item.active && !item?.item?.is_discontinued && item.refill_status === 1) {
    return (
      <Tooltip title="Automatic Refill On">
        <LoopIcon sx={{ color: theme.palette.success.main }} fontSize="small" />
      </Tooltip>
    );
  } else {
    return (
      <Tooltip title="Not on Refill">
        <LoopIcon sx={{ color: theme.palette.inactive.main }} fontSize="small" />
      </Tooltip>
    );
  }
};

export default RefillStatus;
